<!--
     Copyright (c) 2021-2026 Broadcom. All Rights Reserved.
     Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
     and/or its subsidiaries.
-->
<clr-modal [clrModalOpen]="opened"
           (clrModalOpenChange)="closeDialog(false)"
           [clrModalClosable]="false"
           dr-focus>
    <h3 class="modal-title">{{ title | vtranslate }}</h3>
    <div class="modal-body">
        <error-msg [show]="!!errorMsg"
                   [errorMsg]="errorMsg"
                   [type]="errorMsgType"
                   [helpInfoBtn]="helpInfoLbl"
                   [helpInfoUrl]="helpInfoUrl">
        </error-msg>
        <cds-icon *ngIf="type === ConfirmationDialogType.Question"
                  shape="help"
                  class="is-info"
                  size="36"
                  [attr.aria-hidden]="true">
        </cds-icon>
        <cds-icon *ngIf="type === ConfirmationDialogType.Info"
                  shape="info-circle"
                  class="is-info"
                  size="36"
                  [attr.aria-hidden]="true">
        </cds-icon>
        <cds-icon *ngIf="type === ConfirmationDialogType.Warning"
                  shape="warning-standard"
                  class="is-warning"
                  size="36"
                  [attr.title]="'console.dialog.warning.icon' | vtranslate">
        </cds-icon>
        <cds-icon *ngIf="type === ConfirmationDialogType.Error"
                  shape="error-standard"
                  class="is-error"
                  size="36"
                  [attr.title]="'console.dialog.error.icon' | vtranslate">
        </cds-icon>
        <div class="modal-message">
            <div>
                <span [innerHTML]="message"></span>
                <p *ngIf="confirmedConditions?.length > 0">{{ 'console.dialog.confirmation.title' | vtranslate }}</p>
                <clr-checkbox-container *ngFor="let condition of confirmedConditions">
                    <clr-checkbox-wrapper>
                        <input type="checkbox" clrCheckbox required
                               [(ngModel)]="condition.confirmed"/>
                        <label [innerHTML]="condition.text"></label>
                    </clr-checkbox-wrapper>
                </clr-checkbox-container>
            </div>
            <cds-icon *ngIf="customIcon"
                      solid
                      size="xl"
                      [shape]="customIcon"
                      [attr.title]="'console.dialog.product.icon' | vtranslate">
            </cds-icon>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button"
                class="btn btn-outline"
                (click)="closeDialog(false)">
            {{ cancelBtnText | vtranslate }}
        </button>
        <button type="button"
                class="btn"
                [ngClass]="confirmationBtnStyle"
                [clrLoading]="submitting"
                [disabled]="disableSubmitButton()"
                (click)="submit()">
            {{ confirmationBtnText | vtranslate }}
        </button>
    </div>
</clr-modal>
